/**
 * Basic SGActionCommand class
 * @param {string} name SGActionCommand name
 * @param {Object} [params] SGActionCommand parameters
 */
function SGActionCommand(name, params) {
  this.c = name;

  if (params !== null && params !== undefined) {
    this.p = params;
  }
}

export default SGActionCommand;



// WEBPACK FOOTER //
// ./Library/1.0/app/sg-actions/sg-action-command.js